module.exports = __webpack_public_path__ + "img/partner-connect-1.eec27d8b.png";